module.exports = __webpack_public_path__ + "2537fac000ebaad193c4a15014542948.png";